var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteMotoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bgl75bho0b",
    d: "M0 0L25.59 0 25.59 11.915 0 11.915z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uxxqt8ffid",
    d: "M0 0L2.837 0 2.837 2.292 0 2.292z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tyjpa6i1af",
    d: "M0 0L18.339 0 18.339 10.708 0 10.708z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 6.000000) translate(0.835752, 3.701491)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M18.145 8.217c0 1.272-1.034 2.307-2.306 2.307-.682 0-1.323-.308-1.756-.815l3.863-2.432c.131.292.2.61.2.94M2.94 10.55c-.869 0-1.576-.706-1.576-1.575 0-.868.707-1.575 1.576-1.575.868 0 1.575.707 1.575 1.575 0 .869-.707 1.575-1.575 1.575m21.603-5.793c-.964.607-2.242.317-2.849-.647-.607-.964-.316-2.242.647-2.848.32-.201.415-.623.214-.942-.2-.319-.622-.415-.941-.214-1.403.884-1.947 2.623-1.381 4.117l-.564.355c-.988-1.07-2.39-1.694-3.864-1.694-2.897 0-5.255 2.357-5.255 5.254v.001H5.758c-.36-1.215-1.486-2.104-2.817-2.104C1.319 6.034 0 7.353 0 8.974c0 1.622 1.319 2.94 2.94 2.94 1.441 0 2.64-1.041 2.89-2.41h4.903c.107.397.26.781.456 1.143.01.02.018.04.03.06.13.205.352.318.578.318.054 0 .107-.007.16-.02l.012-.003c.018-.004.036-.01.054-.017l.036-.013.04-.019.03-.014.012-.008.02-.01.759-.479c.687.897 1.767 1.447 2.92 1.447 2.024 0 3.67-1.647 3.67-3.672 0-.583-.142-1.155-.405-1.67l1.857-1.17c.657.69 1.564 1.061 2.487 1.061.624 0 1.256-.17 1.822-.526.32-.201.415-.623.214-.942-.2-.319-.622-.415-.941-.214"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M24.748 5.88c.124 0 .25-.035.363-.106l1.471-.926c.32-.201.415-.623.214-.942-.2-.319-.622-.415-.941-.214l-1.472.927c-.319.2-.415.622-.214.941.13.206.352.32.579.32",
    transform: "translate(0.000000, 6.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 6.000000) translate(25.163005, 5.331957)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M2.732.319C2.53 0 2.11-.096 1.79.105L.32 1.032c-.32.2-.415.622-.214.941.13.206.352.32.578.32.125 0 .25-.035.364-.106l1.471-.926c.32-.201.415-.623.214-.942"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M1.28 9.65c.59-1.06 1.929-1.217 2.675-1.217 1.348 0 2.587.751 3.085 1.87.11.246.354.405.623.405h1.368c.148-.01.359-.073.502-.255.018-.023.036-.047.051-.072l2.697-4.423h5.375c.377 0 .683-.306.683-.683 0-.377-.306-.683-.683-.683h-5.51c-.39 0-.758.207-.96.54l-2.24 3.672-1-1.35c-.019-.37-.033-.768-.048-1.184-.065-1.78-.131-3.604-.528-4.905h1.166c.377 0 .683-.305.683-.682C9.22.306 8.913 0 8.536 0H6.313c-.256 0-.49.143-.607.371-.117.228-.097.502.053.71.192.268.334.7.439 1.224l-1.97 4.77c-.09-.004-.182-.008-.273-.008-1.806 0-3.18.681-3.869 1.918-.183.33-.065.745.265.929.329.183.745.065.928-.264"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteMotoRed);
export default __webpack_public_path__ + "static/media/transporteMotoRed.aeaab90b.svg";
export { ForwardRef as ReactComponent };